import styled from 'styled-components';

export const StyledRechartsAreaItem = styled.div`
  margin-bottom: 16px;
`;
